import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fd8fd54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "a8sales" }, null, -1))

import { ref, watch, onMounted, onUnmounted, computed } from 'vue'
import ContactModal from './components/ContactModal.vue'
import {
  TripartiteUserInfo
} from '@/store/modules/tripartite'
import type { Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  setDefault,
  setLaterDefault
} from '@/apis/login'
import { useStore } from 'vuex'
import { PlatProps, Site, UseType } from '@/common/const'
import SignupForm from '@/components/Signup/form.vue'
import { setViewPort, Plat, promotionPluginFn } from './util'
import { isJA, useSite } from '@/store'
import { taSetUser } from '@/util/buryingPoint'
import Header from './components/header.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const { query } = route

const thirdPlatform = computed<TripartiteUserInfo>(
  () => store.state.tripartite.thirdPlatform
)

if (query.channel) {
  /**
   * channel:0 作为独立推广者的渠道
   * channel:N(>0) 作为商务合作的渠道 1: aucfun
   */
  const matchs: any = {
    1: 'af0001'
  }
  store.commit('route/signupQuery', query)
  const match = matchs[query.channel?.toString()]
  if (match) {
    if (query.code?.toString().toLowerCase() !== match) {
      router.push('/404')
    }
  }
} else {
  const signupQuery = store.state.route.signupQuery
  if (signupQuery.channel) {
    router.push({ name: 'signup', query: signupQuery })
  }
}

const step: Ref<number> = ref(store.state.route.uuid ? 2 : 0)
const api = ref(setLaterDefault)
const defaultImageUrl = 'https://static-jp.theckb.com/static-asset/client/sign_up_logo_h5_ja_v4.png'
const defaultLogoUrl = 'url(https://static-jp.theckb.com/static-asset/client/sign_up_logo_h5_ja_v4.png)'
const bgImageUrl = ref(defaultImageUrl)
const logoUrl = ref(defaultLogoUrl)

const anim = ['slideInRight', 'slideOutLeft'].map((v) => 'animated slow ' + v)

let uuid = store.state.route.uuid
// 是否存在uuid
store.commit('route/uuid', '')

watch(
  () => store.getters.site,
  async (site: 'ko' | 'ja' | 'en') => {
    // const site = store.getters.site as 'ko' | 'ja' | 'en'
    switch (site) {
      case 'ko':
        bgImageUrl.value = 'https://static-jp.theckb.com/static-asset/client/loginLogo-ko.png'
        break
      case 'ja':
        bgImageUrl.value = defaultImageUrl
        break
      case 'en':
        bgImageUrl.value = 'https://static-jp.theckb.com/static-asset/client/loginLogo.png'
        break
      default:
        break
    }
  }, {
  immediate: true
}
)

const goto = async () => {
  const res = await api
    .value({
      uuid,
      systemSource: UseType.d2c
    })
  if (res.success) {
    taSetUser(res.data?.customerRespDTO, route)
  }
  const w: any = window
  await store.dispatch('route/changeToken', res.data.token)
  // await updateCustomer2AgencySign()
  if (query.channelRedirect && query.redirect) {
    window.location.replace(decodeURIComponent(query.redirect.toString()))
    router.push(query.redirect.toString())
  } else {
    await store.commit('route/token', res.data.token)
    // router.push('/welcome');
    localStorage._ckb_is_signup_user = 'positive'
    store.commit('route/plat', 'd2c')
    const lang = useSite()
    if (route.query.redirect) {
      window.location.replace(decodeURIComponent(route.query.redirect.toString()))
      router.push(route.query.redirect.toString())
    } else {
      setTimeout(() => {
        location.href = lang === 'ja' ? '/welcome' : `/${lang}/welcome`
      }, 100)
    }
  }
}

/**
 * 根据站点和参数场景判断是跳转选择平台/B2B/D2C
 *  1.非日本站且有uuid 默认进入选择平台
 *  2.日本站需要看站点的来源信息
 */
const stepChange = () => {
  if (route.query.channelRedirect && route.query.redirect) {
    goto()
    return
  }
  // 若是刚进来是别的站点的，需要执行一遍，不会触发watch方法
  goto()
}

const onsuccess = (key: string, channel: string, data: any) => {
  uuid = key
  api.value = setDefault
  stepChange()
  if (!data) return
  promotionPluginFn({
    loginName: data.loginName,
    email: data.customerEmail,
    device: 'h5',
    mobile: data.customerMobile,
    channel: channel,
    uuid: key
  })
}

onMounted(() => {
  setViewPort(Plat.h5)
})

// 如果url 带?channel=itsumo 则不展示line图标
const isItsumoSignup = computed(() => route.query.channel === 'itsumo')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "signup_h5",
    class: _normalizeClass([_unref(isJA)() ? 'japanese' : '', "rel"])
  }, [
    _createVNode(Header),
    _hoisted_1,
    (!_unref(isItsumoSignup))
      ? (_openBlock(), _createBlock(ContactModal, {
          key: 0,
          h5: true,
          type: "signup"
        }))
      : _createCommentVNode("", true),
    _createVNode(SignupForm, {
      h5: true,
      onSuccess: onsuccess,
      ref: (_value, _refs) => {
        _refs['signupFormRef'] = _value
      }
    }, null, 512)
  ], 2))
}
}

})